import React from 'react'

function Services() {


  const sunday_services = [
    {
        name:'Holy Sunday Service',
        description:'Every Sunday (Tamil and Kannada Service)',
        timing:'09:30 AM',
        image:''
    },
    {
        name:'Children Ministry',
        description:'',
        timing:'12:00 Noon',
        image:''
    },
    {
        name:'Youth Ministry',
        description:'',
        timing:'12:30 PM Onwards ',
        image:''
    },
    {
        name:'Holy Sunday Kannada Service',
        description:'',
        timing:'07:00 PM',
        image:''
    },
  ]


  const other_services = [
    {
        name:'Women’s Prayer',
        description:'Every Tuesday',
        timing:'07:00 PM to 08:00 PM',
        image:''
    },
    {
        name:'Online Prayer Meet',
        description:'Every Wednesday',
        timing:'08:00 PM to 09:00 PM',
        image:''
    },
    {
        name:'Fasting Prayer',
        description:'Every Friday',
        timing:'10:30 AM Onwards.',
        image:''
    },
    {
        name:'Dawn prayer',
        description:'1st Date of every month',
        timing:'05:30 AM to 06:30 AM',
        image:''
    },
    {
        name:'Cleansing Prayer for holy communion',
        description:'Every month 2nd Friday and Saturday ',
        timing:'07:00 PM to 08:00 PM',
        image:''
    },
    {
        name:'Holy communion',
        description:'Every month 2nd Sunday',
        timing:'11:30 AM',
        image:''
    }
  ]

  
  return (
    <div>

        <div className="bg-banner4 flex items-center justify-center min-h-[200px] max-h-[200px] md:min-h-[300px] md:max-h-[300px] bg-cover bg-top">
            <h1 className="bg-[#7b026b]/30 z-10 text-white w-max px-10 py-2 md:py-5 text-[16px] md:text-[20px] uppercase font-heading">Our Services</h1>
            <div className='bg-black/60 absolute w-full min-h-[200px] max-h-[200px] md:min-h-[300px] md:max-h-[300px]'>
            </div>
        </div>
      
        <div className='my-5'>
            <h1 data-aos="fade-left" className='text-center text-[#7b026b]/80 font-thicker tracking-widest text-[30px] md:text-[50px]'>SUNDAY PRAYER'S</h1>
            <div className='w-[80%] my-5 gap-4 mx-auto grid grid-cols-1 md:grid-cols-4'>
                 {sunday_services?.map((o,i)=>(
                <div data-aos="fade-up" key={i} className='border bg-white p-2 rounded'>
                    <h6 className='text-[15px] font-heading text-[#7b026b]'>{o?.name}</h6>
                    {o?.description && <h6 className='text-[13px] font-body'>{o?.description}</h6>}
                    <h6 className='text-[13px] font-body'>{o?.timing}</h6>
                </div>))}
            </div>
        </div>

        <div className='my-5'>
            <h1 data-aos="fade-right" className='text-center text-[#7b026b]/80 font-thicker tracking-widest text-[30px] md:text-[50px]'>OTHER PRAYER'S</h1>
            <div className='w-[80%] my-5 gap-4 mx-auto grid grid-cols-2 md:grid-cols-4'>
                {other_services?.map((o,i)=>(
                <div data-aos="fade-up" key={i} className='border bg-white p-2 rounded'>
                    <h6 className='text-[15px] font-heading text-[#7b026b]'>{o?.name}</h6>
                    <h6 className='text-[13px] font-body'>{o?.description}</h6>
                    <h6 className='text-[13px] font-body'>{o?.timing}</h6>
                </div>))}
            </div>
        </div>


    </div>
  )
}

export default Services